<template>
  <v-main>
    <v-container fill-height>
      <v-row class="text-center">
        <v-col>
          <div
            class="display-3"
            v-html="this.$t('message.organization_not_found', { slug: slug })"
          ></div>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: "OrganizationNotFoundPage",
  data() {
    return {
      slug: null
    };
  },
  mounted() {
    this.slug = this.$route.query.slug;
  }
};
</script>

<style scoped></style>
